import styled from 'styled-components/macro'

const SideBarContentWrapper = styled.div`
  display: flex;
`

export default SideBarContentWrapper